import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import config from '../../config/config.js';
import CloseIcon from '@mui/icons-material/Close';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import constants from '../../constant.js';
import { Label } from "flowbite-react";

const ShuttleFare = () => {

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [city, setCity] = useState(cities[0]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [fareData, setFareData] = useState([]);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [fareId, setFareId] = useState('');
    const [status, setStatus] = useState(1);

    // const [title, setTitle] = useState('');
    const [type, setType] = useState(0);
    const [farePerStop, setFarePerStop] = useState('');
    const [baseFare, setBaseFare] = useState('');
    const [farePerKm, setFarePerKm] = useState('');

    const navigate = useNavigate();
    const fetchFareData = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_fare_settings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setFareData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchFareData();
    }, [cityFilter]);

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setType(0);
        setBaseFare('');
        setFarePerKm('');
        setFarePerStop('');
        setStatus(1);
        setFareId('');
    }

    const handleClose = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
        setType('');
        setBaseFare('');
        setFarePerKm('');
        setFarePerStop('');
        setFareId('');
    }

    const handleOpenEdit = (row) => {
        setOpenEditModal(true);
        setType(row.type);
        setBaseFare(row.base_fare);
        setFarePerKm(row.fare_per_km);
        setFarePerStop(row.fare_per_stop);
        setStatus(row.is_active);
        setFareId(row.fare_id);
    }

    const handleSubmit = async() => {
        const token = localStorage.getItem('token');
        if(baseFare==''){
            setMessage('Please enter base fare.');
            showSnackbar(true);
            return;
        }
        if(type==0 && farePerStop==''){
            setMessage('Please enter fare per stop.');
            showSnackbar(true);
            return;
        }
        if(type==0 && farePerStop==0.000){
            setMessage('Fare per stop cannot be zero.');
            showSnackbar(true);
            return;
        }
        if(type==1 && farePerKm==''){
            setMessage('Please enter fare per km.');
            showSnackbar(true);
            return;
        }
        // console.log('fare per km = ', farePerKm);
        if(type==1 && farePerKm==0.000){
            setMessage('Fare per km cannot be zero.');
            showSnackbar(true);
            return;
        }
        if(baseFare==0.000){
            setMessage('Base fare cannot be zero.');
            showSnackbar(true);
            return;
        }
        const payload = {
            token: token,
            type:type,
            base_fare: baseFare,
            city_id: cityFilter,
            // is_active: status
        };
        if(fareId!=''){
            payload.fare_id = fareId;
        }
        if(type==0){
            payload.fare_per_stop = farePerStop;
            payload.fare_per_km = 0;
        }
        if(type==1){
            payload.fare_per_stop = 0;
            payload.fare_per_km = farePerKm;
        }
        if(openEditModal){
            payload.is_active = status;
        }

        try {
            const url = operationsUrl + '/shuttle/add_update_fare_settings';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddModal(false);
                setOpenEditModal(false);
                fetchFareData();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Fare</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Fare
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Type</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare Per Stop</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Base Fare</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare per Km</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {fareData.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                        fareData.map((row) => {

                            return(
                                <TableRow key={row.id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fare_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.type==1 ? 'Fare Per Km' : "Fare Per Stop"}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px', color: row.is_active === 1 ? '#0DBA78' : '#D14545', fontWeight:'500'  }}>{row.is_active==1 ? 'Active' : 'Inactive'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fare_per_stop}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.base_fare}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fare_per_km}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEdit(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {(openAddModal || openEditModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    {openEditModal ? 'Edit Fare' : 'Add Fare'}
                                </Typography>

                                <Grid container spacing={2}>
                                    {/* <Grid item xs={12} sm={6}>
                                        <Label>Title<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Title" fullWidth variant="outlined" type="text" 
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid> */}

                                    <Grid item xs={12} sm={6}>
                                        <Label>Fare Type<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={type} 
                                            fullWidth
                                            onChange={(e) => setType( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            
                                                {Object.entries(constants.fareType).map(([id, label]) => (
                                                    <MenuItem key={id} value={id}>
                                                        {label}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </Grid>

                                    {type==0 && (
                                        <Grid item xs={12} sm={6}>
                                            <Label>Fare Per Stop<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}} type="number"
                                                placeholder="Fare Per Stop" fullWidth variant="outlined"
                                                value={farePerStop}
                                                onChange={(e) => setFarePerStop(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                    )}    

                                    {type==1 && (
                                        <Grid item xs={12} sm={6}>
                                            <Label>Fare per km<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}} type="number"
                                                placeholder="Fare per km" fullWidth variant="outlined"
                                                value={farePerKm}
                                                onChange={(e) => setFarePerKm(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                    )}    


                                    <Grid item xs={12} sm={6}>
                                        <Label>Base Fare<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}} type="number"
                                            placeholder="Base Fare" fullWidth variant="outlined"
                                            value={baseFare}
                                            onChange={(e) => setBaseFare(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    {openEditModal && (
                                        <Grid item xs={12} sm={6}>
                                            <Label>Status<span style={{ color: 'red' }}>*</span></Label>
                                            <Select sx={{marginTop:'2%'}}
                                                value={status} fullWidth
                                                onChange={(e) => setStatus( e.target.value)}
                                                style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                {/* <MenuItem value="">Status</MenuItem> */}
                                                <MenuItem value="1">Active</MenuItem>
                                                <MenuItem value="0">Inactive</MenuItem>
                                            </Select>
                                        </Grid>
                                    )}

                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {openEditModal ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default ShuttleFare;